module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a7d917fce3f62f17717a99e5b3db3a71.png";